import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const LogoutSyncPage = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Clear React auth
    localStorage.removeItem('aurora_token');
    localStorage.removeItem('aurora_user');

    // Redirect to wherever Next.js told us to go
    const redirect = searchParams.get('redirect') ||
      'https://app.auroragh.com/login';
    window.location.href = redirect;
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: 'Inter, sans-serif',
      color: '#64748B',
    }}>
      <p>Logging out...</p>
    </div>
  );
};

export default LogoutSyncPage;